export class HttpError extends Error {

  private responseObject: any;

  constructor(error: any, response: any) {
    super(error);
    this.responseObject = response;
  }

  get response() {
    return this.responseObject;
  }

}

export class ValidationError extends HttpError {
}

export class SessionInvalidError extends HttpError {

}

